import { useEffect, useState } from "react";
import { Carousel, Container, Row, Col } from "react-bootstrap";
import RBImage from "react-bootstrap/Image";
import { Link } from "react-router-dom";
import SliderInfo from "./SliderInfo";
import LoadingOverlay from "./loader/LoadingOverlay";

import hom from "../assets/images/whyus.jpg";
import cors1 from "../assets/images/cors1.jpg";
import cors2 from "../assets/images/cours2.jpg";
import cors3 from "../assets/images/cours3.jpg";

const heroData = [
  {
    id: 1,
    image: cors1,
    title1: "Kanchan Vidya Mandir",
    title2: "Sr. Sec. School",
    quote: "Growing young minds into leaders.",
  },
  {
    id: 2,
    image: cors2,
    title1: "Kanchan Vidya Mandir",
    title2: "Sr. Sec. School",
    quote: "Excellence begins here shaping bright futures.",
  },
  {
    id: 3,
    image: cors3,
    title1: "Kanchan Vidya Mandir",
    title2: "Sr. Sec. School",
    quote: "Enroll now, unlock a brighter future.",
  },
];

function AppHero() {
  const [headerLoading, setHeaderLoading] = useState(true);
  const [aboutImgLoading, setAboutImgLoading] = useState(true);

  useEffect(() => {
    const img = new Image();
    img.src = require("../assets/images/AboutUs1.JPG"); // or import path
    img.onload = () => setHeaderLoading(false);
    img.onerror = () => setHeaderLoading(false);
  }, []);

  // For about section image
  useEffect(() => {
    const img = new Image();
    img.src = hom;
    img.onload = () => setAboutImgLoading(false);
    img.onerror = () => setAboutImgLoading(false);
  }, []);

  return (
    <>
      <section id="home" className="hero-block position-relative">
        {headerLoading && (
          <div
            style={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(255, 255, 255, 0.2)",
              zIndex: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <LoadingOverlay overlayOnly />
          </div>
        )}
        <Carousel fade controls indicators interval={4000}>
          {heroData.map(({ id, image, title1, title2, quote }) => (
            <Carousel.Item key={id}>
              <img className="d-block w-100" src={image} alt={`slide ${id}`} />
              <Carousel.Caption>
                <h1 className="hero-title">{title1}</h1>
                <h1 className="hero-title2">{title2}</h1>
                <h4 className="hero-affiliation">Affiliated to CBSE</h4>
                <h3 className="hero-quote">{quote}</h3>
              </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>
      </section>
      {/* About Section */}
      <section id="about" className="block about-block position-relative">
        <Container fluid className="my-4">
          <div className="title-holder">
            <h2>What sets us apart?</h2>
          </div>
          <Row>
            <Col sm={6} className="position-relative">
              {aboutImgLoading && (
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    backgroundColor: "rgba(255, 255, 255, 0.4)",
                    zIndex: 10,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <LoadingOverlay overlayOnly />
                </div>
              )}
              <RBImage src={hom} style={{ height: "340px" }} fluid />
            </Col>

            <Col sm={6}>
              <p>
                Nestled in the vibrant heart of Faridabad,{" "}
                <strong>Kanchan Vidya Mandir Sr. Sec. School</strong> stands as
                a symbol of transformative education.
              </p>
              <p>
                We go beyond textbooks to ignite curiosity, nurture values, and
                inspire lifelong learning.
              </p>
              <p>
                Our school is more than a place to study — it’s a community
                where students are encouraged to dream big, question boldly, and
                grow with purpose.
              </p>
              <p>
                From academics to arts, sports to leadership, our goal is to
                prepare students not just for exams, but for life — with
                confidence, empathy, and resilience.
              </p>
              <div className="text-center">
                <Link to="/contact">
                  <button className="btn btn-primary btn-lg">Contact Us</button>
                </Link>
              </div>
            </Col>
          </Row>
        </Container>

        <SliderInfo />
      </section>
    </>
  );
}
export default AppHero;
